import type { PersistedTab } from 'apiConnector/tabs/tabs.model';
import type { AppState } from 'state/state.model';

import type { WorkspaceTab } from '../tabs/tabs.model';

export function getWorkspaceDynamicTabQuoteId(state: AppState, tabId: string) {
  return state.workspaces.dynamic[tabId]?.quoteId;
}

export function getPersistedTabFromDynamicWorkspaceTab(state: AppState, tab: WorkspaceTab): PersistedTab {
  const quoteId = getWorkspaceDynamicTabQuoteId(state, tab.id);
  return { ...tab, tabContentType: 'primary', quoteId } as PersistedTab;
}

export function getWorkspaceDynamicTabProductValidation(state: AppState, tabId: string) {
  return !state.workspaces.dynamic[tabId]?.isChoosingProduct;
}
